module.exports = __webpack_public_path__ + "static/media/landing-page.114dd1bf.png";